import React from "react";
import { homePageData } from "./markup";
import Index from "../index";

export default ({ location }) => {
  return <Index pageData={homePageData} location={location} />;
};
